
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'

export default {
data(){
return{
recordList:[]
}
},
components: {
Swipeout, SwipeoutItem, SwipeoutButton
},
mounted(){
this.$http.post('/wuxingHistory',{user_id:this.$route.query.id}).then(res=>{
console.log(res)
if(res.body.code===0){
this.recordList = res.body.result
}
})
},
methods:{
toDetail(type,id){
console.log(type,id)
if(type=='1'){
this.$router.push('/result?id=' + id)
}else{
this.$router.push('/moreResult?id=' + id)
}
},
onButtonDelete(id,type){
this.$http.post('/wuxingIsdelete',{d_id:id,status:type}).then((res)=>{
if(res.body.code===0){
this.$http.post('/wuxingHistory',{user_id:this.$route.query.id}).then(res=>{
console.log(res)
if(res.body.code===0){
this.recordList = res.body.result
}
})
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/recordList.vue